module.exports = __webpack_public_path__ + "img/logo.c256dda4.svg";